/**
 * Formate un montant numérique pour l'affichage (0 décimales pour le FCFA).
 * @param amount - Le montant à formater (nombre ou chaîne).
 * @param showDevise - Si vrai, ajoute " FCFA" à la fin.
 * @returns La chaîne formatée.
 */
export function formatPrice(amount: number | string | undefined | null, showDevise = true): string {
  const num = typeof amount === 'string' ? parseFloat(amount) : (amount ?? 0);
  const formatted = new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);
  
  return showDevise ? `${formatted} FCFA` : formatted;
}

/**
 * Version courte pour l'affichage compact (ex: "888k").
 */
export function formatPriceCompact(amount: number | string | undefined | null): string {
  const num = typeof amount === 'string' ? parseFloat(amount) : (amount ?? 0);
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(0)}k`;
  return String(num);
}
